import { Injectable } from '@angular/core';
import { fromEvent, merge, Observable, Subject } from 'rxjs';

export interface IScannerData {
	prefix: string;
	token: string;
}

@Injectable({
	providedIn: 'root',
})
export class ScannerListenerService {
	public keyBuffer = '';
	public context: string[][] = [];

	constructor() {
		fromEvent<KeyboardEvent>(document, 'keydown').subscribe((e) => {
			if (e.key.length === 1) {
				this.keyBuffer += e.key;
				if (this.keyBuffer.length > 200) this.keyBuffer = this.keyBuffer.slice(100);
			} else if (e.key === 'Enter') {
				this.parseScannerCommand();
				this.keyBuffer = '';
			}
		});

		// A scan arrives as one unbroken run of keystrokes, so a tap or a focus move ends whatever was
		// typed before it. Without this, characters typed earlier without an Enter (a number entered
		// before clicking Next) would be prepended to the next scan.
		merge(fromEvent(document, 'pointerdown'), fromEvent(document, 'focusin'), fromEvent(document, 'focusout')).subscribe(() => (this.keyBuffer = ''));
	}

	public static scannerPrefixes = {
		employeePrefix: 'ACS_E_',
		worktaskPrefix: 'ACS_W_',
		itemPrefix: 'ACS_I_',
		groupPrefix: 'ACS_G_',
	};

	private parseScannerCommand() {
		if (this.context.length === 0) {
			this.keyBuffer = '';
			return;
		}
		const currentContext = this.context[this.context.length - 1];
		let scannerData = { prefix: '', token: this.keyBuffer };
		for (let i = 0; i < currentContext.length; i++) {
			const prefix = currentContext[i];
			const pos = this.keyBuffer.indexOf(prefix);
			if (pos > -1) {
				scannerData = { prefix, token: this.keyBuffer.substring(pos + prefix.length) };
				break;
			}
		}
		this.scannerDataSubject.next(scannerData);
		this.keyBuffer = '';
	}

	private scannerDataSubject: Subject<IScannerData> = new Subject();
	ScannerDataChanged(): Observable<IScannerData> {
		return this.scannerDataSubject;
	}
}
